import { render, staticRenderFns } from "./SecondaryClosed.vue?vue&type=template&id=38fafb62&scoped=true"
import script from "./SecondaryClosed.vue?vue&type=script&lang=js"
export * from "./SecondaryClosed.vue?vue&type=script&lang=js"
import style0 from "./SecondaryClosed.vue?vue&type=style&index=0&id=38fafb62&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38fafb62",
  null
  
)

export default component.exports